<template>
<v-card>
  <v-card-title :class = "shadow ? 'shadow' : ''">
    {{$t('3rd party software')}}
    <v-spacer/>
    <v-icon @click="$emit('input')">mdi-close</v-icon>
  </v-card-title>
  <v-card-text id = "body_license_dialog">
    {{$t('use 3rd party software')}}
    <v-list three-line>
      <v-list-item
        v-for="(item, idx) in modules"
        :key="idx"
        >
        <v-list-item-content class = "list-item">
          <v-list-item-title>{{item.name}}</v-list-item-title>
          <v-list-item-subtitle>
            <span class="d-inline">
              <span class="d-inline-flex">
                <v-icon small>mdi-scale-balance</v-icon>
                <a :href="'license/' + item.licenseFile" download class = "text-decoration-none">{{item.licenseType}}</a>
              </span>
              {{item.copyright}}
            </span>
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            <span class="d-inline">
              <span class="d-inline-flex" v-if = "item.siteUrl !== ''">
                <v-icon x-small>mdi-web</v-icon>
                <a :href="item.siteUrl" target="_blank" class = "text-decoration-none text-caption">{{item.site}}</a>
                &nbsp; &nbsp;
              </span>
              <span class="d-inline-flex">
                <v-icon x-small>mdi-github</v-icon>
                <a :href="item.githubUrl" target="_blank" class = "text-decoration-none text-caption">{{item.github}}</a>
              </span>
            </span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card-text>
</v-card>
</template>

<script>
export default {
  name: 'License',

  components: {
  },

  data: () => ({
    modules: [
      { name: 'Vue 2', licenseType: 'MIT', licenseFile: 'vue/LICENSE', copyright: 'Copyright (c) 2013-present, Yuxi (Evan) You', site: 'v2.vuejs.org', siteUrl: 'https://v2.vuejs.org/', github: 'vuejs/vue', githubUrl: 'https://github.com/vuejs/vue' },
      { name: 'vue router 3', licenseType: 'MIT', licenseFile: 'vue-router/LICENSE', copyright: 'Copyright (c) 2013-present Evan You', site: 'v3.router.vuejs.org', siteUrl: 'https://v3.router.vuejs.org/', github: 'vuejs/vue-router', githubUrl: 'https://github.com/vuejs/vue-router' },
      { name: 'vuex 3', licenseType: 'MIT', licenseFile: 'vuex/LICENSE', copyright: 'Copyright (c) 2015-present Evan You', site: 'v3.vuex.vuejs.org', siteUrl: 'https://v3.vuex.vuejs.org/', github: 'vuejs/vuex', githubUrl: 'https://github.com/vuejs/vuex' },
      { name: 'VuePress', licenseType: 'MIT', licenseFile: 'vuepress/LICENSE', copyright: 'Copyright (c) 2018-present, Yuxi (Evan) You', site: 'v1.vuepress.vuejs.org', siteUrl: 'https://v1.vuepress.vuejs.org/', github: 'vuejs/vuepress', githubUrl: 'https://github.com/vuejs/vuepress' },
      { name: 'Vuetify', licenseType: 'MIT', licenseFile: 'vuetify/LICENSE.md', copyright: 'Copyright (c) 2016-present Vuetify LLC, 2016-2020 John Jeremy Leider', site: 'vuetifyjs.com', siteUrl: 'https://vuetifyjs.com/en/', github: 'vuetifyjs/vuetify', githubUrl: 'https://github.com/vuetifyjs/vuetify' },
      { name: 'Vue I18n 8', licenseType: 'MIT', licenseFile: 'vue-i18n/LICENSE', copyright: 'Copyright (c) 2020 kazuya kawaguchi', site: 'kazupon.github.io/vue-i18n', siteUrl: 'https://kazupon.github.io/vue-i18n/', github: 'kazupon/vue-i18n', githubUrl: 'https://github.com/kazupon/vue-i18n' },
      { name: 'axios', licenseType: 'MIT', licenseFile: 'axios/LICENSE', copyright: 'Copyright (c) 2014-present Matt Zabriskie', site: 'axios-http.com', siteUrl: 'https://axios-http.com/', github: 'axios/axios', githubUrl: 'https://github.com/axios/axios' },
      { name: 'glMatrix 3', licenseType: 'MIT', licenseFile: 'glmatrix/LICENSE.md', copyright: 'Copyright (c) 2015-2021, Brandon Jones, Colin MacKenzie IV', site: 'glmatrix.net', siteUrl: 'https://glmatrix.net/', github: 'toji/gl-matrix', githubUrl: 'https://github.com/toji/gl-matrix' },
      { name: 'fabricjs 6beta', licenseType: 'MIT', licenseFile: 'fabricjs/LICENSE', copyright: 'Copyright (c) 2008-2015 Printio (Juriy Zaytsev, Maxim Chernyak)', site: 'fabricjs.com', siteUrl: 'http://fabricjs.com/', github: 'fabricjs/fabric.js', githubUrl: 'https://github.com/fabricjs/fabric.js' },
      { name: 'OpenStreetMap', licenseType: 'Open Data Commons Open Database License (ODbL)', licenseFile: 'osm/odbl-10.txt', copyright: 'Copyright (c) OpenStreetMap Contributors', site: 'openstreetmap.org', siteUrl: 'https://www.openstreetmap.org/', github: 'openstreetmap', githubUrl: 'https://github.com/openstreetmap' },
      { name: 'OpenLayers', licenseType: 'BSD-2-Clause license ', licenseFile: 'openlayers/LICENSE.md', copyright: 'Copyright (c) 2005-present, OpenLayers Contributors', site: 'openlayers.org', siteUrl: 'https://openlayers.org/', github: 'openlayers/openlayers', githubUrl: 'https://github.com/openlayers/openlayers' },
      { name: 'ol-ext', licenseType: 'CeCILL-B FREE SOFTWARE LICENSE / BSD', licenseFile: 'ol-ext/ol-ext-license.zip', copyright: 'Copyright (c) 2016-20 - Jean-Marc Viglino', site: 'viglino.github.io/ol-ext', siteUrl: 'https://viglino.github.io/ol-ext/', github: 'Viglino/ol-ext', githubUrl: 'https://github.com/Viglino/ol-ext' },
      { name: 'Field of View and Line of Sight in 2D', licenseType: 'BSD-3-Clause license', licenseFile: 'fov/LICENSE', copyright: 'Sundaram Ramaswamy', site: 'legends2k.github.io/2d-fov', siteUrl: 'https://legends2k.github.io/2d-fov/', github: 'legends2k/2d-fov', githubUrl: 'https://github.com/legends2k/2d-fov' },
      { name: 'Material Design', licenseType: 'Pictogrammers Free License (Apache 2.0 / MIT)', licenseFile: 'mdi/LICENSE', copyright: '', site: 'materialdesignicons.com', siteUrl: 'https://materialdesignicons.com/', github: 'Templarian/MaterialDesign', githubUrl: 'https://github.com/Templarian/MaterialDesign' },
      { name: 'docx-templates', licenseType: 'MIT', licenseFile: 'docx-templates/LICENSE.txt', copyright: 'Copyright (c) 2016-2017 Guillermo Grau Panea', site: '', siteUrl: '', github: 'guigrpa/docx-templates', githubUrl: 'https://github.com/guigrpa/docx-templates' },
      { name: 'dxf-viewer', licenseType: 'MPL-2.0 license', licenseFile: 'dxf-viewer/LICENSE', copyright: 'Copyright (c) 2021 dxf-viewer contributors', site: '', siteUrl: '', github: 'vagran/dxf-viewer', githubUrl: 'https://github.com/vagran/dxf-viewer' },
      { name: 'JavaScript-Load-Image', licenseType: 'MIT', licenseFile: 'blueimp-load-image/LICENSE.txt', copyright: 'Copyright © 2011 Sebastian Tschan', site: 'blueimp.net', siteUrl: 'https://blueimp.net', github: 'blueimp/JavaScript-Load-Image', githubUrl: 'https://github.com/blueimp/JavaScript-Load-Image' },
      { name: 'Node.js 12', licenseType: 'MIT and others', licenseFile: 'nodejs/LICENSE', copyright: 'Copyright (c) OpenJS Foundation and Node.js contributor', site: 'nodejs.org', siteUrl: 'https://nodejs.org/en/', github: 'nodejs/node', githubUrl: 'https://github.com/nodejs/node' },
      { name: 'Express', licenseType: 'MIT', licenseFile: 'expressjs/LICENSE', copyright: 'Copyright (c) 2009-2014 TJ Holowaychuk, 2013-2014 Roman Shtylman, 2014-2015 Douglas Christopher Wilson', site: 'expressjs.com', siteUrl: 'https://expressjs.com/', github: 'expressjs/express', githubUrl: 'https://github.com/expressjs/express' },
      { name: 'SQLite 3', licenseType: 'Public Domain', licenseFile: 'sqlite/LICENSE.md', copyright: '', site: 'sqlite.org', siteUrl: 'https://www.sqlite.org/', github: 'sqlite/sqlite', githubUrl: 'https://github.com/sqlite/sqlite' }
    ],
    shadow: false
  }),

  methods: {
    setDrawerHeaderShadow (e) {
      this.shadow = e.target.scrollTop < 24 ? 0 : 1
    }
  },

  mounted () {
    this.$el.querySelector('#body_license_dialog').addEventListener('scroll', this.setDrawerHeaderShadow)
  },

  beforeDestroy () {
    this.$el.querySelector('#body_license_dialog').removeEventListener('scroll', this.setDrawerHeaderShadow)
  }
}

</script>

<style scoped>
.list-item >>> a {
  color: inherit !important
}

.shadow {
  box-shadow: 0px 6px 5px 0px rgba(238, 238, 238, 0.5) !important;
  z-index: 100;
}
</style>
